// import gongSound from './gong.wma';
import gongSound from './gong.mp3';

export const playGong = () => {
  const audio = new Audio(gongSound);
  audio.play();
};
